<template>
  <div class='location'>
    <div v-if="serviceLongitude">
     <el-amap vid="container" :zoom="zoom" :center="center">
          <el-amap-marker></el-amap-marker>
     </el-amap>
    </div>
      <div class="aroundText" v-html="html" >
       
      </div>
      <div class="bottom-img">
        <img src="../assets/image/bottom.png" style="height:1.2rem;" />
      </div>
  </div>
</template>

<script>
import api from '@/script/util'
import AMap from 'vue-amap'
import Vue from 'vue'
import '@/style/frozen.css'
import '@/style/base.css'

Vue.use(AMap)
if (AMap.initAMapApiLoader) {
  AMap.initAMapApiLoader({
    key: '78e2bfb982b0712db9793642e51454ce'
  })
}

export default {
  name: '', // 小镇位置
  data () {
    return {
      amap: 'map',
      zoom: 14,
      center: [],
      html: '',
      serviceLongitude: '',
      serviceLatitude: ''
    }
  },
  created: function () {
    document.title = '小镇位置2'
    let params = {
      townId: api.getVal('townId')
    }
    this.GetCenter(params)
  },
  methods: {
    GetCenter (params) {
      api.GetTownInfo(params)
        .then(res => {
          this.serviceLongitude = res.serviceLongitude
          this.serviceLatitude = res.serviceLatitude
          this.html = res.sellTeamContent
          this.center = [this.serviceLongitude, this.serviceLatitude]
        })
    }
  },
  watch: {
    'serviceLongitude': function () {
      let params = {
        townId: api.getVal('townId')
      }
      this.GetCenter(params)
    }
  }
}
</script>


<style>
.location{
   display: flex;
    flex-direction: column;
    background-color: #fff;
    height: 100%;
}
#container{
  flex:1;
  height: 300px;
  width: 100%;
  background-color: #fff;

}
.el-vue-amap-container{
  height: 300px !important;
}
 .location .aroundText{
    flex:1;
    background-color: #fff;
    margin: .75rem .75rem  2.25rem .75rem;

  }
  .location  .aroundText p {
    display: block;
    width: 100%;
    line-height: 1.2rem;
    padding-bottom: .75rem;
  }
  .location  .aroundText img{
     width:100%;
     border-radius: .2rem;
  }
  .location .bottom-img{
    flex: 0 0 2.5rem;
    display: flex;
    background-color: #fff;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// location.vue?25f05557